import {createSelector } from '@ngrx/store';
import { WebSiteConfig } from './ubs-config-model';
import { ConfigState, EnvState } from './ubs-configuration.state';

export const selectWebConfig = createSelector(
    (state: ConfigState) => state.webSiteConfig,
    (webSiteConfig:WebSiteConfig) => webSiteConfig
  );

export const selectEnv = createSelector(
  (state:EnvState) => state.env,
  (env:any) => env
)